// extracted by mini-css-extract-plugin
export var chip = "_ez-0";
export var filterDropdown = "_ez-5";
export var filterItem = "_ez-6";
export var icon = "_ez-1";
export var removeButton = "_ez-3";
export var removeIcon = "_ez-4";
export var separator = "_ez-2";